import React from 'react';
import { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import Immutable from 'immutable';

import { TaxonomyTheme } from '../../../types/uncinc_profile/taxonomy';

interface ViewParentTaxonomiesProps {
  entities: Immutable.List<ImmutableEntity<TaxonomyTheme>>;
}

const ViewParentTaxonomies: React.FC<ViewParentTaxonomiesProps> = () => {
  return null;
};

export default ViewParentTaxonomies;
